import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

const ResetPassword = () => {
  const [formVisible, setFormVisible] = useState(true);
  const [form] = Form.useForm();

  const onFinish = (values) => {
   
    console.log("Success:", values);
    message.success("Password reset successfully!");
  };

  const handleCancel = () => {
    setFormVisible(false); 
    message.info("Form canceled!");
  };

  if (!formVisible) {
    return null; 
  }

  return (
    <div
      style={{
        maxWidth: 400,
        margin: "50px auto",
        padding: 20,
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: 8,
        backgroundColor: "#fff",
        position: "relative",
      }}
    >
   
      <CloseCircleOutlined
        onClick={handleCancel}
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          fontSize: 20,
          color: "#ff4d4f",
          cursor: "pointer",
        }}
      />

      <h2 style={{ textAlign: "center", marginBottom: 20 }}>Reset Password</h2>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          name="newPassword"
          label="New Password"
          rules={[
            { required: true, message: "Please enter your new password!" },
            {
              min: 6,
              message: "Password must be at least 6 characters long!",
            },
          ]}
          hasFeedback
        >
          <Input.Password placeholder="Enter new password" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          dependencies={['newPassword']}
          rules={[
            { required: true, message: "Please confirm your password!" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("The passwords do not match!"));
              },
            }),
          ]}
          hasFeedback
        >
          <Input.Password placeholder="Confirm new password" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Reset Password
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ResetPassword;
